import React from 'react';

/**
 * Segmented currency picker shared by the premium upgrade modals.
 * One style everywhere (previously brand-500 in one modal, blue-500
 * in the other).
 */
export function CurrencySelector({ currencies, value, onChange, disabled = false, className = '' }) {
  return (
    <div className={`flex justify-center ${className}`}>
      <div
        role="radiogroup"
        aria-label="Choose currency"
        className="inline-flex bg-white dark:bg-gray-700 rounded-lg p-1 border border-gray-200 dark:border-gray-600"
      >
        {currencies.map((currency) => {
          const selected = value === currency;
          return (
            <button
              key={currency}
              type="button"
              role="radio"
              aria-checked={selected}
              disabled={disabled}
              onClick={() => onChange(currency)}
              className={`px-4 py-2 rounded-md font-semibold text-sm transition-all cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed ${
                selected
                  ? 'bg-brand-500 text-white shadow-md'
                  : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-600'
              }`}
            >
              {currency}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default CurrencySelector;
